
export const environment = {
   production: true,
   mfgloc: 'test',
   factory: 'GJMHO',
   api: {
        url: 'https://api.sandbox.kjubsolutions.com/gen/api/v1/ltanalytics/'
   },
   timers: []
};
